import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import "./Navbar.css";
const Navbar = () => {
  const state = useSelector((state) => state.handleCart);
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-white  shadow-sm">
        <div className="container">
          <NavLink className="navbar-brand text-info navv" to="/">
            LOLLOS
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink
                  className="nav-link active"
                  aria-current="page"
                  to="home"
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="Store">
                  Store
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="about">
                  About
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="contact">
                  Contact
                </NavLink>
              </li>
            </ul>
            <div className="buttons">
              <NavLink to="login" className="btn btn-outline-dark ms-2 loginn">
                <i className="fa fa-sign-in me-1"></i> Login
              </NavLink>
              <NavLink
                to="signup"
                className="btn btn-outline-dark ms-2 registerr"
              >
                <i className="fa fa-user-plus me-1 "></i> Register
              </NavLink>
              <NavLink to="cart" className="btn btn-outline-dark ms-2 cartt">
                <i className="fa fa-shopping-cart me-1 "></i> Cart (
                {state.length})
              </NavLink>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
